import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  buttons = [
    {
      icon: 'shopping_cart',
      title: 'MA SELECTION',
      subtitle: 'formation(s)',
      routerLink: 'cart',
      waitLink: true,
      component: 'cart',
      noConnected: true
    }
  ];
  buttonsajoute = [
    {
      icon: 'list_alt',
      title: 'MES FORMATIONS',
      subtitle: 'Formations et documents administratifs (évalution, attestation...)',
      routerLink: 'mesformations/list',
      waitLink: false,
      component: 'default',
      noConnected: false
    },
    {
      icon: 'account_box',
      title: 'MES INFORMATIONS',
      subtitle: 'Coordonnées, contact et information de facturation',
      routerLink: 'mesinformations',
      waitLink: false,
      component: 'default',
      noConnected: false
    },
    {
      icon: 'check',
      title: 'MES PROPOSITIONS COMMERCIALES',
      subtitle: 'Historique de vos commandes et propositions en cours',
      routerLink: 'mespropositionscommerciales',
      waitLink: false,
      component: 'default',
      noConnected: false
    },
    {
      icon: 'folder',
      title: 'MES FACTURES',
      subtitle: 'Historique et documents de facturation',
      routerLink: 'mesfactures',
      waitLink: false,
      component: 'default',
      noConnected: false
    },
    {
      icon: 'exit_to_app',
      title: 'Déconnexion',
      subtitle: '',
      routerLink: '',
      waitLink: false,
      component: 'deconnexion',
      noConnected: false
    }
  ];

  public userConnected = null;
  private subscriberUser;

  constructor(private authService: AuthService, private router: Router) {
    this.userConnected = this.authService.userConnected;
  }

  ngOnInit() {
    this.emptyRouterLink();
    this.subscriberUser = this.authService.userChange.subscribe(user => {
      if (user && user.login) {
        this.ajoutButtons();
      }
    });
    if (this.userConnected && !!this.userConnected.login) {
      this.ajoutButtons();
    }
  }

  ngOnDestroy() {
    this.subscriberUser.unsubscribe();
  }

  ajoutButtons() {
    this.buttons = this.buttons.concat(this.buttonsajoute);
  }

  // en cas de communication avec un autre module, attend l'émission de l'url et le set ici
  changeRouterLink(url: string, index: number) {
    // NB: on change l'url dans un setTimeout pour forcer Angular à recheck la vue sinon ça ne build pas en prod
    setTimeout(() => (this.buttons[index].routerLink = url));
  }

  // en cas de route vide, le clique ne change pas de page
  emptyRouterLink() {
    const currentRoute = this.router.url;
    this.buttons.forEach((button: any) => {
      if (!button.routerLink) button.routerLink = currentRoute;
    });
  }

  // appel le service qui effectue toute la déconnexion (changement de route, et co)
  async signout() {
    await this.authService.signoutAndNavigate();
  }
}
